<template>
  <ul class="space-y-1">
    <li :class="[currentFunnelCategoryId === '' ? 'bg-gray-100 rounded-md' : '']">
      <label class="px-3 py-2 text-sm flex flex-1 items-center select-none">
        <input v-model="currentFunnelCategoryId" type="radio" :value="''" class="hidden" />
        <span class="flex-1 truncate"> All </span>
      </label>
    </li>
    <li
      v-for="funnelCategory in funnelCategories"
      :key="funnelCategory.id"
      :class="[funnelCategory.id === currentFunnelCategoryId ? 'bg-gray-100 rounded-md' : '']"
    >
      <label class="px-3 py-2 text-sm flex flex-1 items-center select-none">
        <input
          v-model="currentFunnelCategoryId"
          type="radio"
          :value="funnelCategory.id"
          class="hidden"
        />
        <span class="flex-1 truncate">
          {{ funnelCategory.name }}
        </span>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    funnelCategories: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    currentFunnelCategoryId: {
      get() {
        return this.value;
      },
      set(funnelCategoryId) {
        this.$emit('input', funnelCategoryId);
      },
    },
  },
};
</script>
